// @ts-strict-ignore
import { Component, EventEmitter, Input } from '@angular/core';
import { ArticleNumberMappingVO } from '../../../model/vo/article-number-mapping.vo';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'invalid-article-number-mapping-import-entries',
  templateUrl: './invalid-article-number-mapping-import-entries.component.html',
})
export class InvalidArticleNumberMappingImportEntriesComponent {

  @Input() invalidMappings: ArticleNumberMappingVO[];

  public update = new EventEmitter<void>();

  constructor(private bsModalRef: BsModalRef) {
  }

  public close(): void {
    this.bsModalRef.hide();
  }
}
